import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { cardsService } from "services";

function CardsHeader() {
  const [data, setData] = useState({
    process: { quantity: 0, value: 0 },
    process_status: [],
    process_no_status: { quantity: 0, value: 0 },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await cardsService.fetch(); // API que retorna a estrutura de data com process, process_status etc.
        setData(response.data); // Armazena todos os dados no estado
      } catch (error) {
        console.error("Erro ao carregar os dados dos cards:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        className="header pb-6"
        style={{
          backgroundColor: "#f8f9fe",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "64px 24px",
          borderBottom: "1px solid #e9ecef"
        }}
      >
        <div style={{
          width: "36px",
          height: "36px",
          border: "3px solid #f0f0f0",
          borderTop: "3px solid #C2641A",
          borderRadius: "50%",
          animation: "cardsHeaderSpin 0.8s linear infinite",
        }} />
        <style>{`@keyframes cardsHeaderSpin { to { transform: rotate(360deg); } }`}</style>
        <p style={{ color: "#525f7f", marginTop: "16px", marginBottom: 0, fontSize: "0.95em", fontFamily: "'Open Sans', sans-serif" }}>
          Carregando os Status dos Cards...
        </p>
      </div>
    );
  }

  return (
    <div className="header pb-6" style={{ backgroundColor: "#f8f9fe", borderBottom: "1px solid #e9ecef" }}>
      <Container fluid>
        <div className="header-body pt-4">
          <Row>
            {/* Card Total de Processos - Destaque em Navy */}
            <Col md="6" xl="3" className="mb-4">
              <Card className="card-stats shadow-sm border-0" style={{ backgroundColor: "#172430", borderRadius: "0.5rem" }}>
                <CardBody className="py-3">
                  <Row className="align-items-center">
                    <div className="col">
                      <h5 className="text-uppercase text-light ls-1 mb-1 small font-weight-bold opacity-8">
                        Total de Processos
                      </h5>
                      <span className="h2 font-weight-700 mb-0 text-white">
                        {data.process.quantity.toString().replace(/(\d)(?=(?:[0-9]{3})+\b)/g, "$1.")}
                      </span>
                    </div>
                    <Col className="col-auto">
                      <div className="icon icon-shape bg-gradient-orange text-white rounded-circle shadow">
                        <i className="ni ni-folder-17" />
                      </div>
                    </Col>
                  </Row>
                  <p className="mt-2 mb-0 text-sm">
                    <span className="text-orange font-weight-600 mr-2">
                        {data.process.value?.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                    </span>
                  </p>
                </CardBody>
              </Card>
            </Col>

            {/* Cards Dinâmicos para Status Individuais */}
            {data.process_status.map((status, index) => (
              <Col key={index} md="6" xl="3" className="mb-4">
                <Card className="card-stats shadow-sm border-0 h-100" style={{ borderRadius: "0.5rem" }}>
                  <CardBody className="py-3 d-flex flex-column justify-content-center">
                    <Row className="align-items-center">
                      <div className="col">
                        <h5 className="text-uppercase text-muted ls-1 mb-1 small font-weight-bold">
                          {status.name}
                        </h5>
                        <span className="h3 font-weight-700 mb-0 text-dark">
                          {status.quantity || 0}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div 
                            className="icon icon-shape rounded-circle shadow-sm" 
                            style={{ 
                                backgroundColor: status.color + '20' || '#C2641A20',
                                color: status.color || '#C2641A'
                            }}
                        >
                          <i className="ni ni-tag" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-2 mb-0 text-sm">
                      <span className="font-weight-600" style={{ color: status.color || "#172430" }}>
                        {(status.value || 0).toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </div>
  );
}

CardsHeader.propTypes = {
  data: PropTypes.object,
};

export default CardsHeader;
  
